import React, { useEffect, useState } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import { useRecoilState } from 'recoil';

import AgGridRowCheckbox from '@/components/common/TableGrid/CustomComponents/AgGridCheckbox/BaseRowCheckbox';
import { checkedIds } from '@/pages/ImportingTool/FileDetails/UsageDetails/checkedIds.state';
import { VarBillingUsageDetailOutput } from '@/graphql/contracts/_generated_/contracts';

interface AgGridHeaderCheckboxProps extends ICellRendererParams<VarBillingUsageDetailOutput> { }

export default function RowCustomCheckbox(params: AgGridHeaderCheckboxProps) {
  const { node, api } = params;
  const [checkedRowIds] = useRecoilState(checkedIds);
  const [isSelected, setSelected] = useState(checkedRowIds.includes(node?.data?.usageDetailID!));

  const onChange = () => {
    setSelected(!isSelected);
  };

  const selectionChanged = () => {
    const isRowSelected = node.isSelected();
    if (typeof isRowSelected === 'undefined') return;
    setSelected(isRowSelected);
  };

  useEffect(() => {
    api.addEventListener('selectionChanged', selectionChanged);

    return () => {
      api.removeEventListener('selectionChanged', selectionChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    node.setSelected(isSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected]);

  return (
    <AgGridRowCheckbox
      {...params}
      id={`custom-grid-row-${node.id}`}
      checked={isSelected}
      onChange={onChange}
    />
  );
}
